import { computed } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";

export const notificationsTypes = computed(() => {
  return {
    all: undefined,
    subscriptions: [NotificationType.SUBSCRIPTION_PURCHASE_PROVIDER],
    purchases: [NotificationType.CONTENT_PURCHASE],
    ...(config.featureFundraisingGoals
      ? {
          goals: [
            NotificationType.FUNDRAISING_GOAL_FINISHED,
            NotificationType.FUNDRAISING_GOAL_STARTED,
            NotificationType.FUNDRAISING_GOAL_DONATION_CREATED,
          ],
        }
      : {}),
    followers: [NotificationType.PROFILE_FOLLOWING],
    likes: [NotificationType.LIKE],
    comments: [NotificationType.POST_REVIEW_CREATED, NotificationType.POST_REVIEW_MENTIONED],
    ...(config.featureAppointments
      ? {
          appointments: [
            NotificationType.APPOINTMENT_REQUESTED,
            NotificationType.APPOINTMENT_CANCELLED_PROVIDER,
            NotificationType.APPOINTMENT_REMINDER_PROVIDER,
          ],
        }
      : {}),
  };
});

export type NotificationsKey = keyof typeof notificationsTypes.value;

export const notificationTypeNames = computed<Record<NotificationsKey, TranslateResult>>(() => {
  return {
    all: $t("All"),
    subscriptions: $t("Subscriptions"),
    purchases: $t("Purchases"),
    goals: $t("Goals"),
    followers: $t("Followers"),
    likes: $t("Likes"),
    comments: $t("Comments"),
    appointments: $t("Appointments"),
  };
});
